var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('Navbar',{attrs:{"id":"nav"}}),(_vm.loading)?_c('div',{attrs:{"id":"request-loading"}},[_vm._v("Loading")]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }